module.exports = "/packs/media/images/Family-465aec24251df06d9517f18d022d5465.png";